import { getTrackBackground, Range as ReactRange } from 'react-range'

import styles from './range.module.scss'
import { FILTER_INITIAL_PAYMENT, FILTER_MONTHLY_PAYMENT } from '@/lib/constants'
import { filterLabelPrettyName } from '@/lib/utilities/search'
import { isProd } from '@/lib/utilities/system'

type RangeProps = {
  filter: string
  filteredTypeName?: string
  step?: number
  availableMinimum: number
  availableMaximum: number
  activeMinimum: number
  activeMaximum: number
  onChange: (values: number[]) => void
  onFinalChange: (values: number[]) => void
  isLoading?: boolean
  showValues?: boolean
}

export const Range = ({
  filter,
  filteredTypeName,
  step = 25,
  availableMinimum = 0,
  availableMaximum = 100,
  activeMinimum = 0,
  activeMaximum = 100,
  onChange,
  onFinalChange,
  isLoading = false,
  showValues = true,
}: RangeProps) => {
  const onRangeChange = (changedValues: number[]) => {
    if (onChange) {
      onChange(changedValues)
    }
  }

  const onFinalRangeChange = (changedValues: number[]) => {
    if (onFinalChange) {
      onFinalChange(changedValues)
    }
  }

  return (
    <div
      className={`${styles.range} ${filter === FILTER_MONTHLY_PAYMENT || filter === FILTER_INITIAL_PAYMENT ? styles['has-margin'] : ''}`}>
      <ReactRange
        disabled={isLoading}
        values={[activeMinimum, activeMaximum]}
        step={step}
        min={availableMinimum}
        max={availableMaximum}
        onFinalChange={values => onFinalRangeChange(values)}
        onChange={values => onRangeChange(values)}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: '2rem',
              display: 'flex',
              width: '100%',
              padding: '0 1rem',
            }}>
            <div
              ref={props.ref}
              style={{
                height: '0.125rem',
                width: '100%',
                borderRadius: '0.25rem',
                background: getTrackBackground({
                  values: [activeMinimum, activeMaximum],
                  colors: ['#7878801F', '#FF2D55', '#7878801F'],
                  min: availableMinimum,
                  max: availableMaximum,
                }),
                alignSelf: 'center',
              }}>
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, index }) => (
          <div
            {...props}
            key={props.key}
            className={!isProd() ? `search__${filteredTypeName?.toLowerCase()}-range-${index === 0 ? 'min' : 'max'}` : ''}
            style={{
              ...props.style,
              height: '2rem',
              width: '2rem',
              borderRadius: '100%',
              backgroundColor: '#FFF',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '0.0625rem solid #7A7A7A29',
              filter: 'drop-shadow(0 0.125rem 0.5rem rgba(0, 0, 0, 0.05))',
            }}></div>
        )}
      />
      {showValues && (
        <div className={styles.values}>
          <span>{filterLabelPrettyName(filter, activeMinimum, filteredTypeName)}</span>
          <span>{filterLabelPrettyName(filter, activeMaximum, filteredTypeName)}</span>
        </div>
      )}
    </div>
  )
}
